const mediaQuery = window.matchMedia('(min-width: 1200px)');

const init = (navItemParent: HTMLElement) => {
  const link : HTMLElement = navItemParent.querySelector(':scope > a');
  const submenu = navItemParent.querySelector(':scope > .children');

  link.addEventListener('click', (e: MouseEvent) => {
    if (!mediaQuery.matches) {
      submenu?.classList.toggle('active');
    }
  });

  navItemParent.addEventListener('pointerenter', () => {
    if (mediaQuery.matches) {
      submenu?.classList.toggle('active');
    }
  });

  navItemParent.addEventListener('pointerleave', () => {
    if (mediaQuery.matches) {
      submenu?.classList.toggle('active');
    }
  });
}

export default init;
